import React from 'react';
import getColor, { isHex } from '../../utils/ColorUtils';
import { colorBg } from './ColorBg.module.scss';

const ColorBg = ({ bgColor }) => {
  const color = getColor(bgColor);
  return (
    <div
      className={`texturedBgVarColor ${colorBg} ${
        isHex(color) ? '' : 'varColor' + color
      } `}
      style={isHex(color) ? { '--var-color': color } : {}}
    />
  );
};
export default ColorBg;
